import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import isCartOpenAtom from './isCartOpenAtom';

const useCloseCart = () => {
  const setIsCartOpen = useSetAtom(isCartOpenAtom);

  const closeCart = useCallback(() => {
    setIsCartOpen(false);
  }, [setIsCartOpen]);

  return closeCart;
};

export default useCloseCart;
